import React from 'react';
import { ButtonIcons, BUTTON_TYPES } from '@tripian/react';
import { useHistory } from 'react-router';
import moment from 'moment';
import { UPDATE_TRIP as UPDATE_TRIP_PATH_TITLE } from '../../../constants/ROUTER_PATH_TITLE';

import useTrip from '../../../hooks/useTrip';

/**
 * Travel Guide
 * Trip Plan
 */
const TripInfoHeader = () => {
  const { tripReference } = useTrip();
  const history = useHistory();

  if (tripReference === undefined) return null;

  const hash = tripReference.trip_hash;
  const cityName = tripReference.city.name;
  const tripArrivalDatetimeMoment = moment(tripReference.trip_profile.arrival_datetime).utcOffset(0);
  const tripDepartureDatetimeMoment = moment(tripReference.trip_profile.departure_datetime).utcOffset(0);
  const lastTripDatetime = moment(tripReference.trip_profile.departure_datetime).format('X');
  const datetimeNow = moment(new Date()).format('X');

  return (
    <div className="day-switch-2">
      <div className="city-name">
        <span className="city-name-span">{cityName}</span>
        {datetimeNow <= lastTripDatetime ? (
          <ButtonIcons.Edit
            type={BUTTON_TYPES.TEXT}
            iconSize="1rem"
            onClick={() => {
              history.push(`${UPDATE_TRIP_PATH_TITLE.PATH}/${hash}`);
            }}
            /* className="hide-s" */
          />
        ) : null}
      </div>
      <div>
        <span>
          {tripArrivalDatetimeMoment.format('MMMM DD')}-{tripDepartureDatetimeMoment.format('DD')}, {tripDepartureDatetimeMoment.format('YYYY')}
        </span>
      </div>
    </div>
  );
};

export default TripInfoHeader;
